<script>
import '/local/templates/redesign/src/assets/scss/pages/loans.scss';
import PageBanner from '../../components-manual/molecules/PageBanner.vue';
import LoansDocs from '../../components-manual/loans/LoansDocs.vue';
import LoansProductList from '../../components-manual/loans/LoansProductList.vue';
import Hotline from '../../components-manual/block/Hotline.vue';
import Advantages from '../../components-manual/molecules/Advantages.vue';
import InterlinkingPages from '../../components-manual/molecules/InterlinkingPages.vue';
export default {
    components: {
        PageBanner,
        LoansDocs,
        LoansProductList,
        Hotline,
        Advantages,
        InterlinkingPages,
    },
};
</script>
